export default __webpack_public_path__ + "static/media/brainport.eb0b2217.jpeg";